import React from 'react';
import {observer} from "mobx-react";
import {FormattedMessage} from "react-intl";
import sanitizeHtml from "sanitize-html";
import {auth} from 'shared/core';

function sanitizeEmailContent(template) {
  const emailContent = auth.locale === 'en' ? template.emailContentEn : template.emailContentFr;

  return sanitizeHtml(emailContent, {
    allowedTags: ['p', 'span', 'br'],
    allowedClasses: {},
    allowedAttributes: {}
  });
}

const EmailTemplatePreview = observer(({template}) => {
  return (
    <div>
      <div className="border px3 py2 bg-haze rounded h4">
        <div className="py1">
          <div dangerouslySetInnerHTML={{__html: sanitizeEmailContent(template)}}/>
        </div>
      </div>
      <div className="mt2 jumbo">
        <FormattedMessage
          id="components.email_template_preview.edit_email_template_link"
          values={{
            link: <a href={`/company_settings/company_email_templates/${template.id}`} target={'_blank'}>
                    <FormattedMessage id="components.email_template_preview.click here"/>
                  </a>
          }}
        />
      </div>
    </div>
  );
});

export default EmailTemplatePreview;
